/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MonitorState } from './monitorState';


export interface MonitorMinResponse { 
    id?: string;
    monitor_name?: string;
    monitor_state?: MonitorState;
}
export namespace MonitorMinResponse {
}


